/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyRules } from '../../models/company-rules';

export interface GetCompanyEmployeeAccessRules$Plain$Params {
  companyId: string;
}

export function getCompanyEmployeeAccessRules$Plain(http: HttpClient, rootUrl: string, params: GetCompanyEmployeeAccessRules$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyRules>> {
  const rb = new RequestBuilder(rootUrl, getCompanyEmployeeAccessRules$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyRules>;
    })
  );
}

getCompanyEmployeeAccessRules$Plain.PATH = '/company/{companyId}/rules';
